module.exports = __webpack_public_path__ + "img/yx_pic3.920964bb.jpg";